import { Jodit } from '@shared/core/jodit-react-ssr';

export const DATA_JOY_DATA = 'data-joy-data';

const customLinkPluginButtons = Jodit.atom(['paragraph', 'bold', 'italic', 'underline', 'insertLink', 'align']);

const customLinkPluginPopupConfig = {
  selection: customLinkPluginButtons,
  a: Jodit.atom([
    {
      name: 'eye',
      tooltip: 'Open link',
      exec: (editor: Jodit, current: HTMLElement): void => {
        const href = Jodit.modules.Helpers.attr(current as HTMLElement, 'href');

        if (current && href) {
          editor.ow.open(href);
        }
      },
    },
    'updateLink',
    'unlink',
    'brush',
    'file',
  ]),
};

const customLinkPluginOptions = {
  onAddLink: (jodit: Jodit, url: string, content: string, data?: string) => {
    jodit.execCommand('applyCustomLink', false, { url, content, data });
  },
};

const customLinkPluginConfig = {
  popup: customLinkPluginPopupConfig,
  customLinkPlugin: customLinkPluginOptions,
  disablePlugins: ['link'],
  buttons: customLinkPluginButtons,
};

export { customLinkPluginConfig };
